export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 bg-gradient-to-br from-teal-500 to-sky-500 rounded-xl flex items-center justify-center shrink-0">
                <i className="ri-heart-pulse-line text-xl text-white"></i>
              </div>
              <span className="text-2xl font-bold text-white" style={{ fontFamily: 'Dancing Script, cursive' }}>
                MomsFirstCare
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-5">
              One platform for pregnancy &amp; baby care from first week to 5 years. Trusted by families across Pune.
            </p>
            <div className="flex items-center gap-2 text-xs text-teal-400 bg-teal-900/30 border border-teal-800/50 rounded-lg px-3 py-2">
              <i className="ri-government-line"></i>
              <span>Govt. of India Guidelines Compliant</span>
            </div>
          </div>

          {/* Platform */}
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Platform</h3>
            <ul className="space-y-2.5">
              {[
                { name: 'How It Works', id: 'how-it-works' },
                { name: 'Features', id: 'features' },
                { name: 'Pregnancy Guide', id: 'pregnancy-tracker' },
                { name: 'Baby Care', id: 'baby-care' }
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-teal-400 transition-colors text-sm whitespace-nowrap cursor-pointer"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Resources</h3>
            <ul className="space-y-2.5">
              {[
                { name: 'Hospital Explorer', id: 'hospitals' },
                { name: 'Cost Calculator', id: 'calculator' },
                { name: 'Map View', id: 'map-view' },
                { name: 'Insights', id: 'insights' }
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-teal-400 transition-colors text-sm whitespace-nowrap cursor-pointer"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Get in Touch</h3>
            <p className="text-gray-400 text-sm mb-4">Have questions or want to collaborate? We'd love to hear from you.</p>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-5 py-2.5 bg-gradient-to-r from-teal-600 to-sky-500 text-white rounded-xl font-semibold text-sm hover:from-teal-700 hover:to-sky-600 transition-all whitespace-nowrap"
            >
              Contact Us
            </button>
            <div className="mt-5 flex items-center gap-2 text-xs text-gray-500">
              <i className="ri-map-pin-line text-teal-500"></i>
              <span>Pune, Maharashtra, India</span>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © 2025 MomsFirstCare. All rights reserved. Built for Indian families.
          </p>
          <div className="flex items-center gap-4 text-sm text-gray-500">
            <a href="/privacy" className="hover:text-teal-400 transition-colors whitespace-nowrap">Privacy Policy</a>
            <span className="text-gray-700">·</span>
            <span className="text-gray-500">Made with ❤️ by Sarthak Bobade</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
